/** Clear obsolete customer earmarks when opening or saving a purchase in the warehouse workflow. */
export function normalizeWarehousePurchaseDraft(values: Record<string, any>, enabled: boolean): Record<string, any> {
  if (!enabled) return values;
  const { customerOrderId, customerOrderLink, itemAllocations, ...purchase } = values;
  return {
    ...purchase,
    purchaseMode: 'STOCK',
    // Explicit nulls also clear values retained by an already mounted Ant Form.
    customerOrderId: null,
    customerOrderLink: null,
    ...(Array.isArray(values.items) ? { items: values.items.map((item: Record<string, any>) => {
      const { sourceOrderProductId, customerQuantity, customerUnit, surplusDisposition, ...stockItem } = item;
      return stockItem;
    }) } : {}),
  };
}
